import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-nova-pro',
  templateUrl: './nova-pro.component.html',
  styleUrls: ['./nova-pro.component.scss']
})
export class NovaProComponent {
constructor(private dialogRef: MatDialogRef<NovaProComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
